import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { TradeOnboardingCoachmark } from '../../global/tradeOnboarding/TradeOnboardingCoachmark';
import { PdpRespTradeDesignManagerOnboardingModal } from '../PdpRespTradeDesignManagerOnboardingModal/PdpRespTradeDesignManagerOnboardingModal';
import { hasSeenPdpTradeDesignManagerOnboardingModal } from '../../global/tradeOnboarding/tradeOnboardingRules';

import { localStorage } from 'dibs-browser-storage';

import styles from './PdpRespTradeDesignManagerOnboardingCoachmark.scss';

const PDP_COACHMARK_DM_VIEWS_LOCAL_STORAGE_KEY = 'pdp_trade_design_manager_onboarding_views';
const PDP_COACHMARK_DM_MAX_VIEWS = 10;
const PDP_COACHMARK_DM_TOOLTIP_DISMISSED = 'pdp_trade_design_manager_onboarding_tooltip_dimissed';

export const pdpCoachmarkMaxViewsExceeded =
    localStorage.getItem(PDP_COACHMARK_DM_VIEWS_LOCAL_STORAGE_KEY) > PDP_COACHMARK_DM_MAX_VIEWS;

export const wasPdpTooltipDismissed = localStorage.getItem(PDP_COACHMARK_DM_TOOLTIP_DISMISSED);

const logCoachmarkViewForItem = () => {
    const views = localStorage.getItem(PDP_COACHMARK_DM_VIEWS_LOCAL_STORAGE_KEY) || 0;
    localStorage.setItem(PDP_COACHMARK_DM_VIEWS_LOCAL_STORAGE_KEY, views + 1);
};

export const logPdpTooltipDismissal = () => {
    localStorage.setItem(PDP_COACHMARK_DM_TOOLTIP_DISMISSED, true);
};

export function PdpRespTradeDesignManagerOnboardingCoachmark(props) {
    const { showModal } = props;
    return (
        <TradeOnboardingCoachmark
            dismissed={wasPdpTooltipDismissed}
            hasSeenModal={hasSeenPdpTradeDesignManagerOnboardingModal()}
            maxViewsExceeded={pdpCoachmarkMaxViewsExceeded}
            logCoachmarkView={logCoachmarkViewForItem}
            logTooltipDismissal={logPdpTooltipDismissal}
            ModalComponent={PdpRespTradeDesignManagerOnboardingModal}
            showModal={showModal}
            tooltipBodyMessage={
                <FormattedMessage
                    id="PdpRespTradeDesignManagerOnboardingCoachmark.bodyText"
                    defaultMessage="Quickly add this item to your {dm} project."
                    values={{ dm: 'Design Manager' }}
                />
            }
            tooltipDirection="bottom"
            tooltipAlign="left"
            tooltipType="coachmark"
            tooltipHeaderMessage={
                <FormattedMessage
                    id="PdpRespTradeDesignManagerOnboardingCoachmark.shopWithConfidence"
                    defaultMessage="Add to {dm}"
                    values={{ dm: 'Design Manager' }}
                />
            }
            wrapperClass={styles.wrapper}
            showCoachmark={!wasPdpTooltipDismissed && !pdpCoachmarkMaxViewsExceeded}
        />
    );
}

PdpRespTradeDesignManagerOnboardingCoachmark.propTypes = {
    showModal: PropTypes.bool,
};
